import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { X } from "lucide-react";

export default function Wishlist() {
  const { wishlist, toggleWishlist } = useStore();
  if (wishlist.length === 0) return (
    <div className="container-luxe py-32 text-center" data-testid="wishlist-empty">
      <h1 className="h-display text-5xl mb-6">Your Wishlist Is Empty</h1>
      <p className="text-sm text-muted-foreground font-light mb-8">Save the pieces you love — they'll be waiting for you here.</p>
      <Link to="/shop" className="btn-primary">Discover The Collection</Link>
    </div>
  );
  return (
    <div className="container-luxe py-16" data-testid="wishlist-page">
      <h1 className="h-display text-5xl sm:text-6xl mb-12">Wishlist</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10">
        {wishlist.map((w) => (
          <div key={w.id} className="group relative" data-testid={`wishlist-item-${w.slug}`}>
            <Link to={`/product/${w.slug}`}>
              <div className="aspect-[4/5] overflow-hidden bg-beige/40"><img src={w.image} alt={w.name} className="h-full w-full object-cover img-zoom" /></div>
            </Link>
            <button onClick={() => toggleWishlist({ id: w.id })} className="absolute right-3 top-3 h-8 w-8 flex items-center justify-center bg-bone/80 backdrop-blur" data-testid={`wishlist-remove-${w.slug}`} aria-label="Remove"><X size={15} /></button>
            <h3 className="font-serif text-xl mt-4">{w.name}</h3>
            <p className="font-display text-sm">${w.price}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
